import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import * as zc from '@dvsl/zoomcharts';

@Component({
  selector: 'app-netchart',
  templateUrl: './netchart.component.html',
  styleUrls: ['./netchart.component.css']
})
export class NetchartComponent implements AfterViewInit {

  @Input() chartID: string;
  @Input() settings: string;
  zc: any = zc;
  chart: any;
  
  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    const NetChart = this.zc.NetChart;
    this.chart = new NetChart(this.settings);
  }

}
